module.exports = __webpack_public_path__ + "static/img/a094.cd228a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a094.jpg
// module id = Q1ON
// module chunks = 0